export class ErrorApi {
  Error: string;
  ErrorDescription: string[];

  public static instanceOfErrorApi(object: any): boolean {
    try {
      return 'ErrorDescription' in object;
    } catch (error) {
      return false;
    }
  }

}


export class ErrorLogin {
  error: string;
  error_description: string;

  public static instanceOfErrorLogin(object: any): boolean {
    try {
      return 'error_description' in object;
    } catch (error) {
      return false;
    }
  }

}
